import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
    lumpsumAmount: 100000,
    tenureInYears: 10,
    expectedReturnRate: 12,
};

// Create a slice
const lumpsumInvestmentCalculatorSlice = createSlice({
    name: 'lumspuminvestment',
    initialState,
    reducers: {
        setLumpsumAmount: (state, action) => {
            state.lumpsumAmount = action.payload;
        },
        setTenureInYears: (state, action) => {
            state.tenureInYears = action.payload;
        },
        setExpectedReturnRate: (state, action) => {
            state.expectedReturnRate = action.payload;
        },
    },
});

// Export actions
export const { setLumpsumAmount, setTenureInYears, setExpectedReturnRate } = lumpsumInvestmentCalculatorSlice.actions;

// Export reducer
export default lumpsumInvestmentCalculatorSlice.reducer;
